import { render, staticRenderFns } from "./PathEditorMenu.vue?vue&type=template&id=f4ef183e&scoped=true&"
import script from "./PathEditorMenu.vue?vue&type=script&lang=js&"
export * from "./PathEditorMenu.vue?vue&type=script&lang=js&"
import style0 from "./PathEditorMenu.vue?vue&type=style&index=0&id=f4ef183e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ef183e",
  null
  
)

export default component.exports